<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Редактировать шаблон квитанции
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'bill-template-details', params: { id: bill_template.id }}">← Назад к Деталям шаблона квитанции</router-link>
    </div>

    <div class="text-right">
      <a v-if="bill_template.id" class="red" href="#" @click.prevent="deleteBillTemplate">удалить шаблон квитанции</a>
    </div>

    <bill-template-edit-form
      :bill-template="bill_template"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getBillTemplate, deleteBillTemplate } from '@/services/bill_template.service'
import billTemplateEditForm from '@/components/forms/bill_template/BillTemplateEditForm'

export default {
  name: 'bill-template-edit',
  components: { billTemplateEditForm },
  data () {
    return {
      bill_template: {
        id: null,
        file: ''
      },

      errors: {
        bill_template: {
          id: [],
          file: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.id !== undefined) {
      this.bill_template.id = this.$route.params.id

      getBillTemplate(this.bill_template.id).then((response) => {
        this.bill_template = response.data
      })
    }
  },
  methods: {
    deleteBillTemplate () {
      deleteBillTemplate(this.bill_template.id).then((response) => {
        this.showMsg('Шаблон квитанции был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'bill-templates' })
        return true
      }).catch(err => {
        this.fillErrors(this.errors.bill_template, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BillTemplateEdit.vue?61b12502